import React from 'react';
import { Resource, ResourceInfo, ResourceProps } from 'omni-package-react-core';
import getApiRoot from '../../utils/getApiRoot';

export const MessagingSummaryResourceInfo: ResourceInfo = {
  name: '/App.features.messages.messagesSummaryResource',
  url: `${getApiRoot()}/messages/summary`,
  dataDst: '/App.features.messages.messagesSummaryCount',
};

const MessagingSummaryResource = <Data, Error = {}>({ ...props }: ResourceProps<Data, Error>) => (
  <Resource
    {...MessagingSummaryResourceInfo}
    {...props}
    transformResponse={({ data }: { data: { newMessageCount: number } }) => (data?.newMessageCount)}
  />
);

export default MessagingSummaryResource;
